<template>
  <div id="app">
    <template v-if="isMaintencanceMode">
      <Maintenance/>
    </template>
    <Experts v-else-if="isExpertsRoute">
      <router-view/>
    </Experts>
    <Default v-else>
      <router-view/>
    </Default>
  </div>
</template>

<script>
import isTokenExpired from './services/auth.isTokenExpired';
import Default from './layouts/Default.vue';
import Experts from './layouts/Experts.vue';
import Maintenance from './views/Maintenance.vue';

export default {
  components: {
    Default,
    Experts,
    Maintenance,
  },
  data() {
    return {
      isMaintencanceMode: /^true$/i.test(process.env.VUE_APP_MAINTENANCE),
      isExpertsRoute: false,
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.user.status.loggedIn;
    },
  },
  watch: {
    $route: {
      // eslint-disable-next-line
      handler: function (route) {
        this.isExpertsRoute = route.name === 'Experts';
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    // Handle $fromApp global variable
    const urlParams = new URLSearchParams(window.location.search);
    const fromAppParam = urlParams.get('fromApp');
    if (fromAppParam) {
      this.$fromApp = fromAppParam;
    }
  },
  mounted() {
    this.$cookiebot.consentBanner();
    if (this.loggedIn && isTokenExpired()) {
      this.$store.dispatch('user/LOGOUT');
    }

    window.addEventListener('CookiebotOnAccept', () => {
      // eslint-disable-next-line
      if (Cookiebot.consent.marketing) {
        // eslint-disable-next-line
        window._paq.push(['trackEvent', 'Cookie', 'Consent', 'Marketing']);
      }
      // eslint-disable-next-line
      if (Cookiebot.consent.preferences) {
        // eslint-disable-next-line
        window._paq.push(['trackEvent', 'Cookie', 'Consent', 'Preferences']);
      }
      // eslint-disable-next-line
      if (Cookiebot.consent.statistics) {
        // eslint-disable-next-line
        window._paq.push(['trackEvent', 'Cookie', 'Consent', 'Statistics']);
      }
    }, false);
  },
};
</script>
